

import { Modal } from "flowbite-react";
import Lottie from "lottie-react";
import { Fragment, useState, useEffect } from "react";
import birthday from "../../assets/lottie/birthday.json";
import image from "../../assets/images/profile-sample.jpg";
import { useSelector } from "react-redux";
import background from "../../assets/images/birthdayBg.png"

const BirthdayModal = ({ isOpen, onCancel }) => {
  const [showContent, setShowContent] = useState(false);
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const user = userInfo?.user || { name: "User", user_info: { dob: null } };
 

  useEffect(() => {
    if (isOpen) {
      setShowContent(false);
      const timer = setTimeout(() => {
        setShowContent(true);
      }, 1000); // Show content after 1 second

      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <Modal show={isOpen} onClose={onCancel} size="xl" popup={true}>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        {!showContent ? (
          <Lottie animationData={birthday} className="w-full h-[312px]" />
        ) : (
          <Fragment className="!h-[300px]" >
          <div className={"absolute top-10 left-0 right-0 "}>
            <img className={"object-cover w-full h-full opacity-40"} src={background} alt={""} />
          </div>
            <div className="text-2xl rounded gap-4 flex flex-col items-center">
            <span className={" text-theme font-medium"}>Happy Birthday</span>
              <div className="w-20 h-20 bg-light rounded-full ">
                <img className="rounded-full" src={image} alt="" />
              </div>
              <span className="font-semibold text-md text-primary-900">{user?.name}</span>
            </div>

            <div className="text-center mb-4 text-cs gap-2 flex flex-col pt-2">
              <p className="text-textLight">
                On behalf 
                of 
                {/* the Principal,  */}
                {/* <b className="text-primary-900">{user?.workspace?.name}</b>, */}
                 {/* and the entire  */}
                 <b className="text-primary-900"> {user?.workspace?.name}</b>, we extend our warmest birthday wishes to
                you! May your special day be filled with joy, success, and
                wonderful moments. Your dedication and presence make our school
                a better place, and we appreciate you greatly.{" "}
              </p>
              <p className="text-primary-900">
                Wishing you a fantastic year ahead! 🎈🎁✨
              </p>
            </div>
          </Fragment>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default BirthdayModal;
